
import Vue from "vue";
import ChatBubble from "@/components/atoms/ChatBubble.vue";
import CatIcon from "@/components/atoms/CatIcon.vue";

export interface ChatMessageProps {
  message: string;
  catIconSize?: "small" | "medium" | "large";
  writerType?: string;
}

export default Vue.extend({
  name: "ChatMessage",
  components: {
    ChatBubble,
    CatIcon,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    catIconSize: {
      type: String,
      default: "medium",
      validator: (value: string) => ["small", "medium", "large"].includes(value),
    },
    writerType: {
      type: String,
      default: null,
    },
  },
});
